// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';
// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_NEWS_API } from "@/constant/apiSettings";

export default {
    extends: baseRentalService,
    data() {
        return {            
            importantInfo: {
                isEnabled: false,
                infoDetail: {}
            },
        };
    },
    computed: {
        isCookiesShow(){
            let isShow = (this.$cookies.get('IsShowImportantNews') && this.$cookies.get('IsShowImportantNews') === 'true');
            return isShow == null ? true : (this.$cookies.get('IsShowImportantNews') && this.$cookies.get('IsShowImportantNews') === 'true');
        }
    },
    mounted() {
        this.getData();
    },
    methods:{
        getData(){
            api.baseRequest(SETTINGS_RENTAL_NEWS_API.GET_IMPORTANT_NEWS)
                .then((res) => {
                    if(res.result === 0){
                        if(res.data !== null) {
                            this.importantInfo.isEnabled = this.isCookiesShow && true;
                            this.importantInfo.infoDetail = {
                                description: res.data.descriptionInHtml,
                                titleShort: res.data.titlE_SHORT,
                                title: res.data.title,
                                url: res.data.url,
                                urlText: res.data.urL_TEXT,
                            };
                        }
                        else{                            
                            this.importantInfo.isEnabled = false;
                            this.importantInfo.infoDetail = null;
                        }
                    }
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "getData failed ...")
                });
        },
        closeOnCurrentSession(){
            this.$cookies.set("IsShowImportantNews", false, 0);
            this.importantInfo.isEnabled = false;
        }
    }
}